import { logout } from '../ReduxStore/features/authSlice'
import AuthService from '../Services/Auth'

const logoutIfNoAuth = (error, dispatch, data) => {
  if (error.response?.status === 401 || error.response?.status === 403) {
    AuthService.logout(data)
    dispatch(logout())
  }
}

export default logoutIfNoAuth
